(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cinematic-intro"] && !Shopify.designMode) return;
  try {
    
(function(){
  var intro = document.getElementById('vt-intro');
  if(!intro) return;

  var frequency = intro.dataset.frequency || 'session';
  var storageKey = 'vt_intro_seen';
  var storage = frequency === 'once' ? window.localStorage : window.sessionStorage;
  if(storage.getItem(storageKey)){
    intro.remove();
    document.dispatchEvent(new CustomEvent('vt:introComplete'));
    return;
  }

  function closeIntro(){
    storage.setItem(storageKey, '1');
    intro.classList.add('is-leaving');
    setTimeout(function(){
      if(intro.parentNode) intro.remove();
      document.dispatchEvent(new CustomEvent('vt:introComplete'));
    }, 800);
  }
  document.getElementById('vt-intro-skip').addEventListener('click', closeIntro);
  var enterBtn = document.getElementById('vt-intro-enter');
  if(enterBtn) enterBtn.addEventListener('click', closeIntro);

  var soundBtn = document.getElementById('vt-intro-sound');
  var audioEl = document.getElementById('vt-intro-audio');
  if(soundBtn && audioEl){
    var playing = false;
    soundBtn.addEventListener('click', function(){
      playing = !playing;
      soundBtn.setAttribute('aria-pressed', String(playing));
      soundBtn.querySelector('.vt-intro__sound-icon').textContent = playing ? '\uD83D\uDD0A' : '\uD83D\uDD07';
      if(playing){ audioEl.play().catch(function(){ playing = false; }); } else { audioEl.pause(); }
    });
  }

  setTimeout(function(){ if(document.body.contains(intro)) closeIntro(); }, 6500);
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeIntro(); });

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(!reducedMotion){
    var field = document.getElementById('vt-intro-particles');
    if(field){
      for(var i=0;i<24;i++){
        var p = document.createElement('span');
        p.className = 'vt-intro__particle';
        p.style.left = (Math.random()*100) + '%';
        p.style.top = (60 + Math.random()*30) + '%';
        p.style.animationDelay = (Math.random()*3) + 's';
        p.style.animationDuration = (3 + Math.random()*2.5) + 's';
        field.appendChild(p);
      }
    }
  }

  var cssStage = document.getElementById('vt-intro-css-stage');
  function isDesktopCapable(){
    var pointerFine = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
    var wideEnough = window.innerWidth >= 900;
    var hasWebGL = false;
    try { var c = document.createElement('canvas'); hasWebGL = !!(window.WebGLRenderingContext && (c.getContext('webgl') || c.getContext('experimental-webgl'))); } catch(e){}
    return pointerFine && wideEnough && hasWebGL;
  }
  function showCssFallback(){ cssStage.hidden = false; }
  function tryGlb(){
    if(!(intro.dataset.glbUrl && isDesktopCapable())){ showCssFallback(); return; }
    var mount = document.getElementById('vt-intro-3d-mount');
    var script = document.createElement('script'); script.type = 'module';
    script.src = 'https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js';
    script.onload = function(){
      mount.hidden = false; cssStage.hidden = true;
      mount.innerHTML = '<model-viewer src="' + intro.dataset.glbUrl + '" auto-rotate camera-controls autoplay style="width:100%;height:100%;"></model-viewer>';
      mount.querySelector('model-viewer').addEventListener('error', function(){ mount.hidden = true; showCssFallback(); });
    };
    script.onerror = function(){ showCssFallback(); };
    document.head.appendChild(script);
  }
  function tryMp4(){
    var isMobile = window.innerWidth < 750;
    var src = isMobile ? intro.dataset.mobileVideo : intro.dataset.desktopVideo;
    if(!src){ tryGlb(); return; }
    var videoEl = document.getElementById('vt-intro-video');
    videoEl.src = src;
    videoEl.addEventListener('error', function(){ videoEl.hidden = true; tryGlb(); }, { once: true });
    videoEl.addEventListener('canplay', function(){ cssStage.hidden = true; videoEl.hidden = false; videoEl.play().catch(function(){ videoEl.hidden = true; tryGlb(); }); }, { once: true });
    setTimeout(function(){ if(videoEl.readyState < 3){ videoEl.hidden = true; tryGlb(); } }, 2500);
  }
  function tryWebm(){
    if(!intro.dataset.webmUrl){ tryMp4(); return; }
    var testEl = document.createElement('video');
    var supportsAlphaWebm = testEl.canPlayType && testEl.canPlayType('video/webm; codecs="vp9"') !== '';
    if(!supportsAlphaWebm){ tryMp4(); return; }
    var webmEl = document.getElementById('vt-intro-webm');
    webmEl.src = intro.dataset.webmUrl;
    webmEl.addEventListener('error', function(){ webmEl.hidden = true; tryMp4(); }, { once: true });
    webmEl.addEventListener('canplay', function(){ cssStage.hidden = true; webmEl.hidden = false; webmEl.play().catch(function(){ webmEl.hidden = true; tryMp4(); }); }, { once: true });
    setTimeout(function(){ if(webmEl.readyState < 3){ webmEl.hidden = true; tryMp4(); } }, 2500);
  }
  function tryLottie(){
    if(!intro.dataset.lottieUrl){ tryWebm(); return; }
    var mount = document.getElementById('vt-intro-lottie-mount');
    var script = document.createElement('script');
    script.src = 'https://unpkg.com/lottie-web/build/player/lottie.min.js';
    script.onload = function(){
      try {
        mount.hidden = false; cssStage.hidden = true;
        var anim = window.lottie.loadAnimation({ container: mount, renderer: 'svg', loop: false, autoplay: true, path: intro.dataset.lottieUrl });
        anim.addEventListener('data_failed', function(){ mount.hidden = true; tryWebm(); });
      } catch(e){ mount.hidden = true; tryWebm(); }
    };
    script.onerror = function(){ tryWebm(); };
    document.head.appendChild(script);
  }

  if(reducedMotion){ showCssFallback(); } else { tryLottie(); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-new-arrivals"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.vt-arrivals__add').forEach(function(btn){
    btn.addEventListener('click', function(){
      if(btn.classList.contains('is-added')) return;
      var originalText = btn.textContent;
      btn.disabled = true; btn.textContent = 'Adding\u2026';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.variantId, 10), quantity: 1 }] })
      }).then(function(r){ return r.json(); }).then(function(){
        btn.textContent = 'Added \u2713';
        btn.classList.add('is-added');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }).catch(function(){
        btn.disabled = false; btn.textContent = originalText;
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-benefits-ai"] && !Shopify.designMode) return;
  try {
    
(function(){
  var trigger = document.getElementById('vt-home-ai-trigger');
  if(!trigger) return;
  trigger.addEventListener('click', function(){
    var fab = document.getElementById('vt-ai-fab');
    if(fab) fab.click();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-polish"] && !Shopify.designMode) return;
  try {
    
(function(){
  var marker = document.getElementById('vt-polish-marker');
  if(!marker) return;

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var allSections = document.querySelectorAll('#MainContent > .shopify-section');
  var sections = Array.prototype.filter.call(allSections, function(s){
    return !s.querySelector('#vt-polish-marker');
  });

  if(reducedMotion || !('IntersectionObserver' in window)){
    sections.forEach(function(s){ s.classList.add('vt-reveal', 'is-visible'); });
    return;
  }

  var observer = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  sections.forEach(function(s, i){
    if(i === 0){ s.classList.add('vt-reveal', 'is-visible'); return; }
    s.classList.add('vt-reveal');
    observer.observe(s);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-free-shipping"] && !Shopify.designMode) return;
  try {
    
(function(){
  var el = document.getElementById('vt-pdp-shipping');
  if(!el) return;
  var threshold = parseInt(el.dataset.threshold, 10);
  var msgEl = document.getElementById('vt-pdp-shipping-message');
  var fillEl = document.getElementById('vt-pdp-shipping-fill');

  function formatMoney(cents){ return '$' + (cents/100).toFixed(2); }

  function render(cartTotal){
    var pct = Math.min(100, Math.max(0, (cartTotal / threshold) * 100));
    fillEl.style.width = pct + '%';
    var remaining = threshold - cartTotal;
    if(cartTotal === 0){
      msgEl.textContent = 'Free delivery on orders over ' + formatMoney(threshold);
    } else if(remaining <= 0){
      msgEl.textContent = "\uD83C\uDF89 You've unlocked free delivery!";
    } else {
      msgEl.textContent = "You're " + formatMoney(remaining) + ' away from free delivery.';
    }
  }

  function refresh(){
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){ render(cart.total_price); }).catch(function(){});
  }

  document.addEventListener('cart:refresh', refresh);
  document.addEventListener('cart:update', refresh);
  refresh();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recently-viewed"] && !Shopify.designMode) return;
  try {
    
(function(){
  var KEY = 'vt_recently_viewed_v1';
  var wrap = document.getElementById('vt-pdp-recent');
  var track = document.getElementById('vt-pdp-recent-track');
  var currentScript = document.getElementById('vt-pdp-recent-current');
  if(!wrap || !track || !currentScript) return;

  function getList(){ try{ return JSON.parse(localStorage.getItem(KEY) || '[]'); }catch(e){ return []; } }
  function setList(list){ try{ localStorage.setItem(KEY, JSON.stringify(list)); }catch(e){} }
  function money(cents){ return '$' + (cents/100).toFixed(2); }

  var current = JSON.parse(currentScript.textContent);
  var list = getList().filter(function(p){ return p.handle !== current.handle; });

  if(list.length){
    track.innerHTML = '';
    list.slice(0, 4).forEach(function(p){
      var a = document.createElement('a');
      a.href = p.url; a.className = 'vt-pdp-recent__card';
      a.innerHTML = (p.image ? '<img src="'+p.image+'" alt="'+p.title.replace(/"/g,'')+'" loading="lazy">' : '') +
        '<p>'+p.title+'</p><p class="vt-pdp-recent__price">'+money(p.price)+'</p>';
      track.appendChild(a);
    });
    wrap.hidden = false;
  }

  list.unshift(current);
  setList(list.slice(0, 12));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-social-share"] && !Shopify.designMode) return;
  try {
    
(function(){
  var btn = document.getElementById('vt-pdp-share-copy');
  var status = document.getElementById('vt-pdp-share-status');
  if(!btn) return;
  btn.addEventListener('click', function(){
    var url = btn.dataset.url;
    if(navigator.clipboard && navigator.clipboard.writeText){
      navigator.clipboard.writeText(url).then(function(){
        status.textContent = 'Link copied.';
        setTimeout(function(){ status.textContent = ''; }, 3000);
      }).catch(function(){ status.textContent = 'Could not copy link.'; });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-experience"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.getElementById('vt-scroll-experience');
  if(!root) return;

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var storageKey = 'vt_scroll_experience_done';
  var closed = false;
  var isMobile = window.innerWidth < 750;
  var activeScrollTrigger = null;

  function markDone(){
    if(closed) return;
    closed = true;
    sessionStorage.setItem(storageKey, '1');
    window.removeEventListener('scroll', mobileLiteScrollHandler);
    if(activeScrollTrigger){
      activeScrollTrigger.kill();
      activeScrollTrigger = null;
    }
    document.dispatchEvent(new CustomEvent('vt:introComplete'));
  }

  document.getElementById('vtscroll-skip').addEventListener('click', function(){
    root.style.display = 'none';
    document.body.style.overflow = '';
    markDone();
  }, { once: true });

  if(sessionStorage.getItem(storageKey) || reducedMotion){
    if(reducedMotion){ markDone(); } else { root.style.display = 'none'; markDone(); }
    return;
  }

  function isLowPerfDevice(){
    var lowCores = navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 4;
    var lowMemory = navigator.deviceMemory && navigator.deviceMemory <= 4;
    var conn = navigator.connection;
    var slowConn = conn && (conn.saveData || conn.effectiveType === 'slow-2g' || conn.effectiveType === '2g' || conn.effectiveType === '3g');
    return !!(lowCores || lowMemory || slowConn);
  }

  var useLiteMode = isMobile && isLowPerfDevice();

  var scrollLengthVh = isMobile
    ? (parseInt(root.dataset.scrollLengthMobile, 10) || 250)
    : (parseInt(root.dataset.scrollLengthDesktop, 10) || 500);
  root.style.height = scrollLengthVh + 'vh';

  if(useLiteMode){
    initLiteMode();
    return;
  }

  var script1 = document.createElement('script');
  script1.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
  script1.onload = function(){
    var script2 = document.createElement('script');
    script2.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js';
    script2.onload = function(){ isMobile ? initMobileGsap() : initDesktopGsap(); };
    script2.onerror = function(){ initLiteMode(); };
    document.head.appendChild(script2);
  };
  script1.onerror = function(){ initLiteMode(); };
  document.head.appendChild(script1);

  function spawnParticles(count){
    var field = document.getElementById('vtscroll-particles');
    for(var i=0;i<count;i++){
      var p = document.createElement('span');
      p.className = 'vtscroll__particle';
      p.style.left = (Math.random()*100) + '%';
      p.style.top = (Math.random()*100) + '%';
      field.appendChild(p);
    }
  }

  function initDesktopGsap(){
    var gsap = window.gsap;
    gsap.registerPlugin(window.ScrollTrigger);
    spawnParticles(18);

    var tl = gsap.timeline({
      scrollTrigger: { trigger: root, start: 'top top', end: 'bottom bottom', scrub: 0.6, onLeave: markDone }
    });
    activeScrollTrigger = tl.scrollTrigger;

    tl.to('#vtscroll-logo', { scale: 0.6, y: -120, duration: 1 }, 0);
    tl.to('.vtscroll__particle', { opacity: 0.7, stagger: 0.02, duration: 0.5 }, 0.1);
    tl.to('#vtscroll-box-wrap', { opacity: 1, duration: 1 }, 0.8);
    tl.fromTo('#vtscroll-box', { rotateY: -50, z: -200 }, { rotateY: 0, z: 0, duration: 1.5 }, 0.8);
    tl.to(['#vtscroll-ribbon-v', '#vtscroll-ribbon-h'], { opacity: 0, scaleX: 1.3, duration: 1 }, 2.2);
    tl.to('#vtscroll-lid', { rotateX: -115, y: -10, duration: 1.2 }, 2.4);
    tl.to('#vtscroll-box-glow', { opacity: 1, duration: 1 }, 2.6);

    var products = root.querySelectorAll('.vtscroll__product');
    var positions = [
      { x: -90, y: -60, r: -12 }, { x: -50, y: -110, r: 8 }, { x: 0, y: -130, r: -6 },
      { x: 50, y: -110, r: 10 }, { x: 90, y: -60, r: -8 }, { x: 0, y: -80, r: 4 }
    ];
    products.forEach(function(el, i){
      var pos = positions[i % positions.length];
      tl.to(el, { opacity: 1, x: pos.x, y: pos.y, rotate: pos.r, duration: 1 }, 3.2 + (i * 0.25));
    });

    tl.to('#vtscroll-story-1', { opacity: 1, duration: 0.6 }, 4.8);
    tl.to('#vtscroll-story-1', { opacity: 0, duration: 0.6 }, 5.6);
    tl.to('#vtscroll-story-2', { opacity: 1, duration: 0.6 }, 5.8);
    tl.to('#vtscroll-story-2', { opacity: 0, duration: 0.6 }, 6.6);

    tl.to(products, { opacity: 0, x: 0, y: 0, duration: 1 }, 6.8);
    tl.to('#vtscroll-box-wrap', { opacity: 0, duration: 1 }, 7.2);
    tl.to('#vtscroll-logo', { opacity: 0, duration: 0.8 }, 7.4);
  }

  function initMobileGsap(){
    var gsap = window.gsap;
    gsap.registerPlugin(window.ScrollTrigger);
    spawnParticles(8);

    var tl = gsap.timeline({
      scrollTrigger: { trigger: root, start: 'top top', end: 'bottom bottom', scrub: 0.5, onLeave: markDone }
    });
    activeScrollTrigger = tl.scrollTrigger;

    tl.to('#vtscroll-logo', { scale: 0.65, y: -80, duration: 1 }, 0);
    tl.to('.vtscroll__particle', { opacity: 0.6, stagger: 0.03, duration: 0.4 }, 0.1);
    tl.to('#vtscroll-box-wrap', { opacity: 1, duration: 0.8 }, 0.7);
    tl.fromTo('#vtscroll-box', { scale: 0.85, opacity: 0 }, { scale: 1, opacity: 1, duration: 1 }, 0.7);

    tl.to(['#vtscroll-ribbon-v', '#vtscroll-ribbon-h'], { opacity: 0, duration: 0.7 }, 1.8);
    tl.to('#vtscroll-lid', { rotateX: -110, y: -8, duration: 1 }, 1.9);
    tl.to('#vtscroll-box-glow', { opacity: 1, duration: 0.7 }, 2.1);

    var mobileProducts = root.querySelectorAll('.vtscroll__product[data-mobile="1"]');
    var positions = [ { x: -55, y: -60 }, { x: -18, y: -95 }, { x: 18, y: -95 }, { x: 55, y: -60 } ];
    mobileProducts.forEach(function(el, i){
      var pos = positions[i % positions.length];
      tl.to(el, { opacity: 1, x: pos.x, y: pos.y, duration: 0.8 }, 2.6 + (i * 0.2));
    });

    tl.to('#vtscroll-story-1', { opacity: 1, duration: 0.5 }, 3.5);
    tl.to('#vtscroll-story-1', { opacity: 0, duration: 0.5 }, 4.0);

    tl.to(mobileProducts, { opacity: 0, x: 0, y: 0, duration: 0.7 }, 4.3);
    tl.to('#vtscroll-box-wrap', { opacity: 0, duration: 0.7 }, 4.6);
    tl.to('#vtscroll-logo', { opacity: 0, duration: 0.6 }, 4.8);
  }

  var liteTicking = false;
  function mobileLiteScrollHandler(){
    if(liteTicking) return;
    liteTicking = true;
    requestAnimationFrame(function(){
      var rect = root.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      var progress = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 0;

      document.getElementById('vtscroll-logo').style.opacity = progress < 0.5 ? String(1 - progress) : '0';
      document.getElementById('vtscroll-box-wrap').style.opacity = progress > 0.15 && progress < 0.85 ? '1' : '0';
      var lid = document.getElementById('vtscroll-lid');
      if(progress > 0.3){ lid.style.transform = 'rotateX(-105deg) translateY(-6px)'; }
      else { lid.style.transform = 'none'; }
      document.getElementById('vtscroll-box-glow').style.opacity = progress > 0.35 ? '1' : '0';

      var mobileProducts = root.querySelectorAll('.vtscroll__product[data-mobile="1"]');
      var visible = progress > 0.45 && progress < 0.8;
      var positions = [ { x: -50, y: -55 }, { x: -16, y: -85 }, { x: 16, y: -85 }, { x: 50, y: -55 } ];
      mobileProducts.forEach(function(el, i){
        el.style.opacity = visible ? '1' : '0';
        el.style.transform = visible ? 'translate(' + positions[i].x + 'px,' + positions[i].y + 'px)' : 'translate(0,0)';
      });

      var story = document.getElementById('vtscroll-story-1');
      story.style.opacity = (progress > 0.55 && progress < 0.75) ? '1' : '0';

      if(progress >= 0.98){ markDone(); }
      liteTicking = false;
    });
  }
  function initLiteMode(){
    window.addEventListener('scroll', mobileLiteScrollHandler, { passive: true });
    mobileLiteScrollHandler();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-page-ajax"] && !Shopify.designMode) return;
  try {
    
(function(){
  var grid = document.getElementById('vt-shop-grid');
  var gridStatus = document.getElementById('vt-shop-grid-status');
  var cardsWrap = document.getElementById('vt-shop-cards');
  var header = document.getElementById('vt-shop-collection-header');
  var searchInput = document.getElementById('vt-shop-search-input');
  var searchClear = document.getElementById('vt-shop-search-clear');
  var searchStatus = document.getElementById('vt-shop-search-status');
  if(!grid || !cardsWrap) return;

  var activeCollectionUrl = null;
  var debounceTimer = null;
  var currentController = null;
  var htmlCache = {};

  function skeletonHTML(){
    var cards = '';
    for(var i=0;i<8;i++){ cards += '<div class="vt-shop__skeleton-card"></div>'; }
    return '<div class="vt-shop__skeleton">' + cards + '</div>';
  }

  function setActive(url){
    cardsWrap.querySelectorAll('[data-shop-card]').forEach(function(card){
      card.classList.toggle('is-active', card.dataset.collectionUrl === url);
    });
  }

  function renderHeader(card){
    if(!card){ header.hidden = true; header.classList.remove('is-visible'); return; }
    var title = card.dataset.collectionTitle || '';
    var desc = card.dataset.collectionDescription || '';
    var count = card.dataset.collectionCount || '0';
    var image = card.dataset.collectionImage || '';
    var html = '';
    if(image){ html += '<img class="vt-shop__collection-header__image" src="' + image + '" alt="' + title + '" loading="lazy">'; }
    html += '<h2 class="vt-shop__collection-header__title">' + title + '</h2>';
    if(desc){ html += '<p class="vt-shop__collection-header__desc">' + desc + '</p>'; }
    html += '<p class="vt-shop__collection-header__count">' + count + ' items</p>';
    header.innerHTML = html;
    header.hidden = false;
    requestAnimationFrame(function(){ header.classList.add('is-visible'); });
  }

  function applyContent(html, url, push, card){
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var content = doc.querySelector('.shopify-section') || doc.body;
    grid.innerHTML = '';
    grid.appendChild(content.cloneNode(true));
    grid.classList.remove('is-loading');
    setActive(url);
    renderHeader(card);
    if(push){ window.history.pushState({ vtShop: true, url: url }, '', url); }
    if(gridStatus){
      var countMatch = content.textContent.match(/([\d,]+)\s+(?:product|item)/i);
      gridStatus.textContent = countMatch ? (countMatch[1] + ' products shown') : 'Products updated';
    }
    grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function loadCollection(url, push, card){
    activeCollectionUrl = url;
    if(htmlCache[url]){
      applyContent(htmlCache[url], url, push, card);
      return;
    }
    grid.classList.add('is-loading');
    grid.innerHTML = skeletonHTML();
    if(currentController){ currentController.abort(); }
    currentController = ('AbortController' in window) ? new AbortController() : null;
    fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=main', currentController ? { signal: currentController.signal } : {})
      .then(function(r){ return r.text(); })
      .then(function(html){
        htmlCache[url] = html;
        applyContent(html, url, push, card);
      })
      .catch(function(err){
        if(err && err.name === 'AbortError') return;
        window.location.href = url;
      });
  }

  cardsWrap.querySelectorAll('[data-shop-card]').forEach(function(card){
    card.addEventListener('click', function(e){
      e.preventDefault();
      searchInput.value = '';
      searchClear.hidden = true;
      loadCollection(card.dataset.collectionUrl, true, card);
    });
  });

  window.addEventListener('popstate', function(e){
    if(e.state && e.state.vtShop){ loadCollection(e.state.url, false, null); }
  });

  grid.addEventListener('click', function(e){
    var target = e.target.closest('a, button');
    if(!target) return;
    var href = target.getAttribute('href');
    var looksLikePagination =
      (href && /[?&]page=\d+/.test(href)) ||
      target.closest('[class*="pagination"]') ||
      target.getAttribute('aria-label') === 'Next' ||
      target.getAttribute('aria-label') === 'Previous' ||
      (target.textContent || '').trim().toLowerCase() === 'next' ||
      (target.textContent || '').trim().toLowerCase() === 'load more';
    if(!looksLikePagination) return;
    if(href){
      e.preventDefault();
      window.location.href = href;
    }
    else if(activeCollectionUrl){
      var beforeCount = grid.querySelectorAll('a[href*="/products/"]').length;
      setTimeout(function(){
        var afterCount = grid.querySelectorAll('a[href*="/products/"]').length;
        if(afterCount <= beforeCount){ window.location.href = activeCollectionUrl; }
      }, 1500);
    }
  });

  function runSearch(query){
    if(!query){
      searchStatus.textContent = '';
      if(activeCollectionUrl){ loadCollection(activeCollectionUrl, false, null); }
      else { grid.innerHTML = ''; header.hidden = true; }
      return;
    }
    grid.classList.add('is-loading');
    grid.innerHTML = skeletonHTML();
    searchStatus.textContent = 'Searching\u2026';
    if(currentController){ currentController.abort(); }
    currentController = ('AbortController' in window) ? new AbortController() : null;

    var base = activeCollectionUrl ? activeCollectionUrl : '/search';
    var url = activeCollectionUrl
      ? base + '?q=' + encodeURIComponent(query) + '&section_id=main'
      : '/search?q=' + encodeURIComponent(query) + '&type=product&section_id=main';

    fetch(url, currentController ? { signal: currentController.signal } : {})
      .then(function(r){ return r.text(); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.querySelector('.shopify-section') || doc.body;
        grid.innerHTML = '';
        grid.appendChild(content);
        grid.classList.remove('is-loading');
        var count = content.querySelectorAll('[data-variant-id], .product-card, a[href*="/products/"]').length;
        searchStatus.textContent = count > 0 ? ('Results for \u201c' + query + '\u201d') : ('No products found for \u201c' + query + '\u201d');
      })
      .catch(function(err){
        if(err && err.name === 'AbortError') return;
        searchStatus.textContent = 'Search is temporarily unavailable \u2014 please browse categories instead.';
        grid.classList.remove('is-loading');
      });
  }

  if(searchInput){
    searchInput.addEventListener('input', function(){
      var val = searchInput.value.trim();
      searchClear.hidden = val === '';
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function(){ runSearch(val); }, 400);
    });
    searchInput.addEventListener('keydown', function(e){
      if(e.key === 'Escape'){ searchInput.value = ''; searchClear.hidden = true; runSearch(''); searchInput.blur(); }
    });
  }
  if(searchClear){
    searchClear.addEventListener('click', function(){
      searchInput.value = ''; searchClear.hidden = true; runSearch(''); searchInput.focus();
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-page-layout"] && !Shopify.designMode) return;
  try {
    
(function(){
  var toggle = document.getElementById('vt-shoplayout-toggle');
  var sidebar = document.getElementById('vt-shoplayout-sidebar');
  var close = document.getElementById('vt-shoplayout-close');
  var backdrop = document.getElementById('vt-shoplayout-backdrop');
  if(!toggle || !sidebar) return;
  function open(){ sidebar.classList.add('is-open'); backdrop.classList.add('is-open'); }
  function shut(){ sidebar.classList.remove('is-open'); backdrop.classList.remove('is-open'); }
  toggle.addEventListener('click', open);
  close.addEventListener('click', shut);
  backdrop.addEventListener('click', shut);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-sidebar-nav"] && !Shopify.designMode) return;
  try {
    
(function(){
  var toggle = document.getElementById('vt-shopnav-toggle');
  var sidebar = document.getElementById('vt-shopnav-sidebar');
  var close = document.getElementById('vt-shopnav-close');
  var backdrop = document.getElementById('vt-shopnav-backdrop');
  if(!toggle || !sidebar) return;
  function open(){ sidebar.classList.add('is-open'); backdrop.classList.add('is-open'); }
  function shut(){ sidebar.classList.remove('is-open'); backdrop.classList.remove('is-open'); }
  toggle.addEventListener('click', open);
  close.addEventListener('click', shut);
  backdrop.addEventListener('click', shut);
})();

  } catch(e) { console.error(e); }
})();
})();
